import { IconeProprio, type PropsIcone } from './base'

/**
 * Ícone próprio de cinemática do trauma veicular (movimento + colisão).
 *
 * Representa a física do impacto: vetor direcional de deslocamento/velocidade,
 * veículo em desaceleração contra barreira fixa indeformável e ondas de choque
 * no ponto exato de colisão do para-choque.
 */
export function IconeCinematica(props: PropsIcone) {
  return (
    <IconeProprio {...props}>
      {/* Barreira fixa de impacto / obstáculo com base de ancoragem */}
      <path d="M3 4v16" />
      <path d="M1.5 20h3" />
      {/* Marcador de energia e deformação no ponto de impacto */}
      <path d="M4.8 11.5L3.2 13.5l1.6 2" />
      <path d="M6.2 10l-1.6 3.5 1.6 3.5" />
      {/* Silhueta aerodinâmica do veículo em desaceleração */}
      <path d="M7.5 14.5h3.5l2.5-5h4.5l3.5 5v3H7.5v-3z" />
      <circle cx="10" cy="17.5" r="1.5" />
      <circle cx="18.5" cy="17.5" r="1.5" />
      {/* Vetor de cinemática: direção e avanço de energia cinética */}
      <path d="M20 5.5H9" />
      <path d="M12 3L8.5 5.5 12 8" />
    </IconeProprio>
  )
}

/** Compatibilidade com o registro de módulos. */
export const IconeModuloCinematica = IconeCinematica
